<header class="header" [ngClass]="{'mobile-menu-opened': mobileMenuState, 'no-dropdown': forceCloseDropDown }" *ngIf="!showGameHeader">

  <a class="header__logo-wrapper" routerLink="/">
    <brt-logo></brt-logo>
  </a>

  <nav class="header-navigation" (click)="forceCloseMenu()">
    <ul class="header-navigation__first-level">
      <li class="header-navigation__main-item header-navigation__main-item--has-dropdown" [ngClass]="{'opened': currentSubmenuItem === 0}" (focusout)="onDropdownMenuFocusOut($event, this)">
        <a href="#" class="header-navigation__main-item-title" (click)="toggleSubmenuItem($event, 0)">{{'MENU.PROFESSIONS.MAIN_TITLE' | translate }} <span class="icon-dropdown" aria-label="Icon Dropdown"></span></a>
        <ul class="header-navigation__second-level header-navigation__second-level--single-column"  [attr.aria-hidden]="currentSubmenuItem === 0 ? null : 'true'">
          <li class="header-navigation__secondary-item">
            <brt-submenu-item [canFocus]="currentSubmenuItem === 0" [link]="'/berufe/'" [icon-url]="'/assets/img/teaser/Berufe-erforschen.svg'" [title]="'MENU.PROFESSIONS.DISCOVER_TITLE' | translate" [abstract]="'MENU.PROFESSIONS.DISCOVER_ABSTRACT' | translate"></brt-submenu-item>
          </li>
          <li class="header-navigation__secondary-item">
            <brt-submenu-item [canFocus]="currentSubmenuItem === 0" [link]="'/berufe/interessensfelder'" [icon-url]="'/assets/img/teaser/Berufe-erforschen-Interessensfelder.svg'" [title]="'MENU.PROFESSIONS.FEELS_INTEREST_TITLE' | translate" [abstract]="'MENU.PROFESSIONS.FEELS_INTEREST_ABSTRACT' | translate"></brt-submenu-item>
          </li>
          <li class="header-navigation__secondary-item">
            <brt-submenu-item [canFocus]="currentSubmenuItem === 0" [link]="'/berufe/anforderungen/'" [icon-url]="'/assets/img/teaser/Berufe-erforschen-Staerken.svg'" [title]="'MENU.PROFESSIONS.STRENGTHS_INTEREST_TITLE' | translate" [abstract]="'MENU.PROFESSIONS.STRENGTHS_INTEREST_ABSTRACT' |translate"></brt-submenu-item>
          </li>
        </ul>


      </li>
      <li class="header-navigation__main-item">
        <a class="header-navigation__main-item-title" routerLink="/einblicke">{{'MENU.INSIGHTS.MAIN_TITLE' | translate }}</a>
      </li>
      <li class="header-navigation__main-item">
        <a class="header-navigation__main-item-title" routerLink="/anbieter">{{ "MENU.PROVIDERS.MAIN_TITLE" | translate }}</a>
      </li>
      <li class="header-navigation__main-item">
        <a class="header-navigation__main-item-title" routerLink="/jobboerse">{{"MENU.JOBS.MAIN_TITLE" | translate }}</a>
      </li>
      <li class="header-navigation__main-item header-navigation__main-item--has-dropdown" [ngClass]="{'opened': currentSubmenuItem === 1}" (focusout)="onDropdownMenuFocusOut($event, this)">
        <a href="#" class="header-navigation__main-item-title" (click)="toggleSubmenuItem($event,1)" tabindex="0">{{"MENU.INFO_OFFERS.MAIN_TITLE" | translate }} <span class="icon-dropdown" aria-label="Icon Dropdown"></span></a>
        <ul class="header-navigation__second-level" [attr.aria-hidden]="currentSubmenuItem === 1 ? null : 'true'">
          <li class="header-navigation__secondary-item">
            <brt-submenu-item [canFocus]="currentSubmenuItem === 1" [link]="'/infos-angebote/angebote-lehrpersonen'" [icon-url]="'/assets/img/teaser/Angebote-Lehrpersonen.svg'" [title]="'MENU.INFO_OFFERS.OFFERS_TEACHER_TITLE' | translate" [abstract]="'MENU.INFO_OFFERS.OFFERS_TEACHER_ABSTRACT' | translate"></brt-submenu-item>
          </li>
          <li class="header-navigation__secondary-item">
            <brt-submenu-item [canFocus]="currentSubmenuItem === 1" [target]="'_blank'" [link]="'https://blog.berufsreise.at'" [icon-url]="'/assets/img/teaser/Blog.svg'" [title]="'MENU.INFO_OFFERS.BLOG_STUDENTS_TITLE' | translate" [abstract]="'MENU.INFO_OFFERS.BLOG_STUDENTS_ABSTRACT' |translate"></brt-submenu-item>
          </li>
          <li class="header-navigation__secondary-item">
            <brt-submenu-item [canFocus]="currentSubmenuItem === 1" [link]="'/infos-angebote/infos-lehrpersonen'" [icon-url]="'/assets/img/teaser/Ideen-Lehrpersonen.svg'" [title]="'MENU.INFO_OFFERS.IDEAS_TEACHER_TITLE' | translate" [abstract]="'MENU.INFO_OFFERS.IDEAS_TEACHER_ABSTRACT' |translate"></brt-submenu-item>
          </li>
          <li class="header-navigation__secondary-item">
            <brt-submenu-item [canFocus]="currentSubmenuItem === 1" [link]="'gewinnspiel'" [icon-url]="'/assets/img/teaser/gewinnspiel.svg'" [title]="'MENU.INFO_OFFERS.LOTTERY_TITLE' | translate" [abstract]="'MENU.INFO_OFFERS.LOTTERY_ABSTRACT' | translate"></brt-submenu-item>
          </li>
          <li class="header-navigation__secondary-item">
            <brt-submenu-item [canFocus]="currentSubmenuItem === 1" [link]="'/infos-angebote/unternehmen'" [icon-url]="'/assets/img/teaser/Ideen-Unternehmen.svg'" [title]="'MENU.INFO_OFFERS.IDEAS_COMPANY_TITLE' | translate" [abstract]="'MENU.INFO_OFFERS.IDEAS_COMPANY_ABSTRACT' |translate"></brt-submenu-item>
          </li>
          <li class="header-navigation__secondary-item">
            <brt-submenu-item [canFocus]="currentSubmenuItem === 1" [link]="'/infos-angebote/faq'" [icon-url]="'/assets/img/teaser/FAQ.svg'" [title]="'MENU.INFO_OFFERS.FAQ_TITLE' | translate" [abstract]="'MENU.INFO_OFFERS.FAQ_ABSTRACT' | translate"></brt-submenu-item>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
  <ul class="header__meta-items">
    <li class="header__meta-item header__meta-item--icon search" (click)="openAccessibilityMenu($event)">
      <button role="button" #accessibilityButton>
        <brt-icon [icon]="'accessibility'"></brt-icon>
      </button>
    </li>

    <li class="header__meta-item header__meta-item--icon search" (click)="openGlobalSearch($event)">
      <button role="button">
        <brt-icon [icon]="'search'"></brt-icon>
      </button>
    </li>

    <li class="header__meta-item header__meta-item--icon" (click)="openSelfAssessmentOverlay()">
      <button role="button">
        <brt-wizard-icon></brt-wizard-icon>
      </button>
    </li>

    <li class="header__meta-item">
      <div brtItemActions [trigger-type]="'hover'" [items]="bookmarksActionMenu" [title]="'Deine Merkliste'">
        <button role="button">
          <brt-favorites-icon [favoriteItemsNumber]="favoriteItemsNumber"></brt-favorites-icon>
        </button>
      </div>
    </li>

    <li class="header__meta-item header__meta-item--button">
      <ng-container *ngIf="isAnyLoggedIn; else loginMenu;">
        <brt-timer-button [iconRight]="'dropdown'" class="header__timer-button" brtItemActions [items]="logoutActionMenu" [trigger-type]="'hover'" *ngIf="loggedInType === 'school'"></brt-timer-button>
        <brt-button  [title]="'Profil'" [color]="'red'" brtItemActions [items]="logoutActionMenu" [trigger-type]="'hover'" *ngIf="loggedInType === 'provider'"></brt-button>
      </ng-container>
      <ng-template #loginMenu>
        <brt-button  [title]="'Anmelden'" [color]="'red'" brtItemActions [items]="loginActionMenu" [trigger-type]="'hover'"></brt-button>
      </ng-template>

<!--        <brt-button *ngIf="!isLoggedIn()" (click)="login()" [title]="'Anmelden'" [color]="'red'"></brt-button>-->

<!--        <brt-button (click)="getUser()" [title]="'Get User'" [color]="'red'"></brt-button>-->
<!--      <a href="https://www2.berufsreise.at/login" target="_blank">-->
<!--      </a>-->
    </li>
  </ul>
  <div class="header__mobile-menu-trigger" (click)="toggleMobileMenu()">
    <div class="header__mobile-menu-trigger-opened">
      <brt-icon [icon]="'burger-close'"></brt-icon>
    </div>
    <div class="header__mobile-menu-trigger-closed">
      <brt-icon [icon]="'burger'"></brt-icon>
    </div>
  </div>
</header>


<header class="header header--game" [ngClass]="{'mobile-menu-opened': mobileMenuState, 'no-dropdown': forceCloseDropDown }" *ngIf="showGameHeader" brtBorderGradient [color]="'blue'">

  <div class="header__logo-wrapper" (mouseenter)="onLogoMouseEnter()">
    <brt-lottie class="header__logo-icon" [lottieOptions]="{path: '/assets/lottie-animations/Arrow_02.json', autoplay: false, loop: false}" (instanceCreated)="onLogoAnimCreated($event)"></brt-lottie>
    <span class="header__logo-label">{{"CLASS_DASHBOARD.HEADER.HEADLINE" | translate}}</span>
  </div>

  <nav class="header-navigation" (click)="forceCloseMenu()">
    <ul class="header-navigation__first-level">
      <li class="header-navigation__main-item header-navigation__main-item--has-dropdown">
        <span class="header-navigation__main-item-title">{{"CLASS_DASHBOARD.HEADER.GAMES" | translate}} <span class="icon-dropdown"></span></span>
        <ul class="header-navigation__second-level header-navigation__second-level--single-column" brtBorderGradient [color]="'blue'">
          <li class="header-navigation__secondary-item" *ngFor="let gameItem of gameSubmenuItems">
            <brt-submenu-item [data]="gameItem"></brt-submenu-item>
          </li>
        </ul>


      </li>
      <li class="header-navigation__main-item">
        <a class="header-navigation__main-item-title" (click)="openRankingList()">{{"CLASS_DASHBOARD.HEADER.POSITION_LIST" | translate}}</a>
      </li>
      <li class="header-navigation__main-item">
        <a class="header-navigation__main-item-title" (click)="openTrophiesList()">{{"CLASS_DASHBOARD.HEADER.TROPHIES" | translate}}</a>
      </li>
    </ul>
  </nav>
  <ul class="header__meta-items">



    <li class="header__meta-item header__meta-item--button header__meta-item--timer-button">
      <brt-timer-button></brt-timer-button>
    </li>

    <li class="header__meta-item header__meta-item--icon logout" (click)="logoutStudent()">
      <brt-icon [icon]="'logout'"></brt-icon>
    </li>
  </ul>
  <div class="header__mobile-menu-trigger" (click)="toggleMobileGameMenu()">
    <div class="header__mobile-menu-trigger-opened">
      <brt-icon [icon]="'burger-close'"></brt-icon>
    </div>
    <div class="header__mobile-menu-trigger-closed">
      <brt-icon [icon]="'burger'"></brt-icon>
    </div>
  </div>
</header>

<div class="header__boxes-wrapper" *ngIf="showGameHeader">
  <brt-header-home-box></brt-header-home-box>
  <brt-header-organization-data></brt-header-organization-data>
</div>


